export { default as useIsMounted } from './useIsMounted';
export * from './useIsMounted';
//# sourceMappingURL=index.js.map